/* eslint-disable */
const sdk = {};

function magic(name, options) {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  const params = JSON.stringify(options) || '{}';
  console.log(`调用app方法-${name}: ${params}`);
  if (isiOS) {
    return window.webkit.messageHandlers[name].postMessage(params);
  }
  if (isAndroid) {
    return jsCallApp[name](params);
  }
}

sdk.doPrint = options => {
  return magic('doPrint', options);
};

sdk.logonStateFailure = options => {
  return magic('logonStateFailure', options);
};

sdk.skip2OrderDetail = options => {
  return magic('skip2OrderDetail', options);
};

sdk.getStatusBarHeight = options => {
  return magic('getStatusBarHeight', options);
};

sdk.showLoading = options => {
  return magic('showLoading', options);
};

sdk.closeLoading = options => {
  return magic('closeLoading', options);
};

sdk.skipBack = options => {
  return magic('skipBack', options);
};

sdk.openDownloadUrl = options => {
  return magic('openDownloadUrl', options);
};

sdk.getSystemInfo = options => {
  return magic('getSystemInfo', options);
};

sdk.toMergePay = options => {
  return magic('toMergePay', options);
};

sdk.backHome = options => {
  return magic('backHome', options);
};

sdk.messageBox = options => {
  return magic('messageBox', options);
};

sdk.toSubPage = options => {
  return magic('toSubPage', options);
};

sdk.toTabPage = options => {
  return magic('toTabPage', options);
};

sdk.scanQrcode = options => {
  return magic('scanQrcode', options);
};

sdk.skip2OrderFun = options => {
  return magic('skip2OrderFun', options);
};

sdk.getApplocation = options => {
  return magic('getApplocation', options);
};

sdk.setRoleType = options => {
  return magic('setRoleType', options);
};

sdk.getRoleType = options => {
  return magic('getRoleType', options);
};

sdk.getUserInfo = options => {
  return magic('getUserInfo', options);
};

sdk.startDetect = options => {
  return magic('startDetect', options);
};

sdk.modifyDetectResult = options => {
  return magic('modifyDetectResult', options);
};

sdk.dataClear = options => {
  return magic('dataClear', options);
};

sdk.takeRealMachinePhoto = options => {
  return magic('takeRealMachinePhoto', options);
};

sdk.scanSerialNum = options => {
  return magic('scanSerialNum', options);
};

sdk.wxPayResult = options => {
  return magic('wxPayResult', options);
};

sdk.getPayId = options => {
  return magic('getPayId', options);
};

sdk.appTel = options => {
  return magic('appTel', options);
};

sdk.appShare = options => {
  return magic('appShare', options);
};

sdk.saveImage = options => {
  return magic('saveImage', options);
};

sdk.skip2DetectV3Detail = options => {
  return magic('skip2DetectV3Detail', options);
};

export default sdk;
